import { Component, Input, ViewEncapsulation } from '@angular/core';
import { AppConfigService } from 'src/app/Services/app-config.service';
import { ShoreexcursionsService } from 'src/app/Services/shoreexcursions.service';
// import { excursionDialogComponent } from '../excursion-dialog/excursion-dialog.component';

import * as moment from 'moment';
import { Time } from '@angular/common';
import { MatDialog } from '@angular/material/dialog';
import { ItiCodesService } from 'src/app/Services/iti-codes.service';
import { UserData } from 'src/app/Models/employee-and-user-data';
import { cruiseContentEvtCodeFromSession } from 'src/app/utils/voyage-pms-code';

type iticodeInfo = {
  evtCode: string; 
  llcitiCode: string; 
  llcltcUid: number; 
  llcuid: number;
  ltcName: string; 
  ltcUid: number;
  itiBegDate: Date;
  locallooptoday: boolean; 
  localloopfuture: boolean; 
};

type shoreexcursions = {
  Type: string;
  Name: string;
  Description: string;
  BegDate: Date;
  EndDate: Date;

  rebcode: string;
  rebuid: number;
  folioid: number;
  evtCode: string;
  GuestName: string;
  expander: boolean;
  deduper: boolean;
  priordateequal: boolean;
};

@Component({
  selector: 'app-shore-excursions-cruise',
  templateUrl: './shore-excursions-cruise.component.html',
  styleUrls: ['./shore-excursions-cruise.component.css'],
  providers: [ShoreexcursionsService],
  encapsulation: ViewEncapsulation.None,
})
export class ShoreExcursionsCruiseComponent {
  @Input() inputdate: string | undefined;
      
  CurrentDate: any;
  itiBegDate: any;

  userdata?: UserData;
  cruiseCode: string | undefined;
  OBPortalSvcURL = '';

  shoreexcursionsInfo: shoreexcursions[] = [];
  shoreexcursiondata: any;
  asofdate: string | undefined;

  evtCode: string | undefined;
  evtcode: string | undefined;

  itiName: string | undefined; 
  ltcName: string | undefined; 
  itiCode: string | undefined;

  iticodedata: any; 
  iticodes: iticodeInfo[] = [];
  shoreexcursiondataLocalloop: any; 
  shoreexcursionsInfoLocalloop: any;
  shoreexcursiondataNotlocalloop: any; 
  shoreexcursionsInfoNotlocalloop: any;

  shoreexcursiondataEnd: any;


  imagepath = '';

  constructor(
    private appConfigService: AppConfigService,
    public dialog: MatDialog,
    private ItiCodesService: ItiCodesService,
    private ShoreexcursionsService: ShoreexcursionsService,
  ) {}

  ngOnInit() {
    this.OBPortalSvcURL = this.appConfigService.OBPortalSvcURL;
    this.userdata = JSON.parse(localStorage.getItem('userinfo') || '{}');
    const voyage = cruiseContentEvtCodeFromSession(this.userdata);
    this.cruiseCode = voyage;
    this.evtCode = voyage;
    this.itiName = this.ltcName;
    this.itiCode = this.userdata?.evtcode;
    this.asofdate = moment().format('YYYY-MM-DD');
    this.CurrentDate = moment().startOf('day').toDate();
    this.getShoreExcursions();
  }
  datecompare(date1: Date, date2: Date) {
    if (date1.toString().substring(0, 10) == date2.toString().substring(0, 10))
      return true;
    else return false;
  }

  getShoreExcursions() {
    this.shoreexcursiondata =
      this.ShoreexcursionsService.getCruiseShoreExcursions(
        this.cruiseCode
      ).subscribe((shoreexcursiondata) =>
        this.setshoreexcursions(shoreexcursiondata)
      );
  }

  setshoreexcursions(resdata: any) {
    this.shoreexcursiondata = resdata;
    if (this.shoreexcursiondata.GetCruiseExcursions.Result.Status == 'A') {
      this.shoreexcursionsInfo =
        this.shoreexcursiondata.GetCruiseExcursions.ShoreExcursionsList;

      for (let i = 0; i < this.shoreexcursionsInfo?.length; i++) {
        if (this.shoreexcursionsInfo[i].deduper == true)
          this.shoreexcursionsInfo.splice(i, 1);
      }
      for (let i = 0; i < this.shoreexcursionsInfo?.length; i++) {
        if (
          i > 0 &&
          this.datecompare(
            this.shoreexcursionsInfo[i].BegDate,
            this.shoreexcursionsInfo[i - 1].BegDate
          )
        ) {
          this.shoreexcursionsInfo[i].priordateequal = true;
        } else if (i == 0) this.shoreexcursionsInfo[i].priordateequal = false;
      }
      this.getItiCodes();
    }
  }

  getItiCodes() {
    this.iticodedata = this.ItiCodesService.getItiCodes(
      this.evtCode
    ).subscribe((iticodedata) => this.setItiCodes(iticodedata));
  }
  setItiCodes(resdata: any) {
    this.iticodedata = resdata; 
    if (this.iticodedata.GetItiCodes.Result.Status == 'A') {
      this.iticodes = this.iticodedata.GetItiCodes.ItiCodesList.filter(
        
        // if the ltcName ("Newport Local Loop: Newport, RI | AM") has a space then a | in it
        (s: { ltcName: string }) =>
          (s.ltcName.includes(' |')
        )); 
        //  remove everything after the space and | 
        this.iticodes.forEach((currentValue, index) => {
          
        if (currentValue.ltcName.includes(' |'))
          currentValue.ltcName = currentValue.ltcName.split(' |')[0]

        currentValue.itiBegDate = moment(currentValue?.itiBegDate).startOf('day').toDate();
        
        if (moment(currentValue?.itiBegDate).isSame(this.CurrentDate,'day'))
            currentValue.locallooptoday = true;

        if (moment(currentValue?.itiBegDate).isAfter(this.CurrentDate,'day'))
          currentValue.localloopfuture = true;

        });
      }
    }


}
